// removed by extract-text-webpack-plugin
module.exports = {"boxDev":"_2HIDzTcChIs4ZlP2F3r4F5","availableBox":"_1MdZbh9FLpzSYN0G5SqIUv","downApp":"_3vjMteu1zSbuEvfzxieCzx"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/IsDevelop.scss
// module id = 1173
// module chunks = 0